import React, {Component} from 'react';
import {connect} from 'react-redux';
// utils
import {Translations} from '../../../utils';
// constant
import {FORM_REFS} from '../../../constants';
// restClient
import {aemHostClient, eapiClient} from '../../../restClient';
// children
import Dynamicform from '../../common/Dynamicform/dynamicForm';
//action Creator
import {hideActionButton} from '../../layouts/actions/actionCreator';
import {updateCase} from '../../createAcase/actions/actionCreator';
import {blockUi, unBlockUi} from '../../../actions/actionCreator';

class CreateNewGLSproduct extends Component{
  constructor(props){
    super(props);
    this.state = {};
  }

  componentWillMount(){
    let apiURL = "/aemData/formData/json_add-gls";
    if(this.props.mode === "edit"){
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
      this.setState({formJson: data});
    });
  }

  checkForm = () => {
    let apiURL = "/aemData/formData/json_add-gls";
    if(this.props.mode === "edit"){
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`;
      this.setState({formJson: data});
    })
  }

  componentDidMount(){
    this.props.hideActionButton();
  }

  getFormData = (formData) => {
    this.setState({formData});
  }

  electingCases(obj,searchKey){
     for(var key in obj){
         if(obj[key].entityName === searchKey){
             return key
         }
     }
  }

  submitFormData = (event,apiURL) => {
    let productInfo = this.state.formData.glsProductType.value
    let handleForm = this.props.glsProductDetails.some( type => type.glsProductType.value === productInfo )

    if(handleForm){
      this.setState({btnDisabled:false})
      alert(`You have already added one ${this.state.formData.glsProductType.name} product. Please select another product`)
    }else {
      this.onFormSubmit(event,apiURL)
    }
  }

  onFormSubmit = (event, apiURL) => {
    this.props.blockUi();
     let caseId= this.electingCases(this.props.cases, this.state.formData.glsAgent.name);
     // if(Object.keys(this.props.entities) === this.state.formData.glsAgent.value){
     //      caseId = this.props.entities[this.state.formData.glsAgent.value].caseId;
     //  };
      var requestData = {};
      requestData.caseId = caseId;
      if(this.state.formData.glsProductType.value === 'notionalPool'){
        //requestData.notionalPooling = this.state.formData;
        requestData = {
          ...this.state.formData,
          notionalPooling: {},
          caseId
        }
      } else if(this.state.formData.glsProductType.value ==='cashcon'){
        //requestData.cashConcentration = this.state.formData;
        requestData = {
          ...this.state.formData,
          caseId,
          cashConcentration: {}
        }
      } else if(this.state.formData.glsProductType.value ==='interest'){
        requestData = {
          ...this.state.formData,
          interestEnhancement: {},
          caseId
        }
        //requestData.interestEnhancement = this.state.formData;
      }
      if(this.props.mode === 'edit') {
        apiURL = apiURL + "/" + this.state.formData.id;
      }
      var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
      eapiClient(apiURL, {
        method: METHOD,
        data: JSON.stringify(requestData)
      })
      .then(({data}) => {
        var {caseId} = data.responseData;
        this.props.updateCase(caseId, 'glsproducts', Object.assign({}, this.props.formData, {id: data.responseData.id}));
        // this.props.history.push("/create-a-case/add-gls");
        this.props.history.goBack();
        this.props.unBlockUi();
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups(){
    let formData;
    let mode
    if(this.props.currentglsProduct !== undefined) {
      formData = {...this.props.currentglsProduct};
    }else if(Object.keys(this.props.glsAgent).length > 0){
       formData ={
         glsAgent:this.props.glsAgent
       }
       mode='edit'
    }
    else {
      formData = {};
    }
    const properties = {
      glsProductId: this.props.match.params.glsProductId,
      caseId: this.props.match.params.caseId,
      formData,
      editType: 'add-glsProduct-to-case',
      pathname: this.props.history.location.pathname
    };
    if(this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined){
      var test = this.props.mode === 'edit' && this.props.mode !== '' ? true : false;
      console.log(test);
      return (
        <Dynamicform
        properties={properties}
        url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
        getFormData={this.getFormData}
        onFormSubmit={this.submitFormData}
        onFormCancel={this.onFormCancel}
        lang = {this.props.lang.currentLang.lang}
        mode={Object.keys(this.props.glsAgent).length > 0 ? 'edit' : ''}
        translatedData ={this.props.lang.translatedData}
        btnDisabled = {this.state.btnDisabled}
        flag={this.props.lang.currentLangFlag.flag}
        resetDisable = {this.props.mode === 'edit' && this.props.mode !== '' ? true : false}
        />
      );

    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render(){
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : '';
    return(
      <div className="form-container">
      <div className="form-title">
      <h2 className="form-heading">{this.translations(pageTitle.pageHeading)}</h2>
      <p className="form-required-desc">{this.translations(pageTitle.descriptionText)}</p>
      </div>
      {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentglsProduct = undefined;
  if(props.match.params) {
    var {caseId, glsProductId} = props.match.params;
    if(caseId && glsProductId && state.cases[caseId] && state.cases[caseId]['glsproducts'][glsProductId]){
      currentglsProduct = state.cases[caseId]['glsproducts'][glsProductId]
    }
  }
  return {
    currentglsProduct,
    cases:state.cases,
    entities:state.entities,
    mode: currentglsProduct !== undefined ? 'edit' : '',
    lang: state.lang,
    glsAgent: state.glsAgent,
    glsProductDetails: state.productDetails.gls
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    updateCase: (caseId, productType, productData) => {
      dispatch(updateCase(caseId, productType, productData))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewGLSproduct);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CreateNewGlsProduct.js